<template>
  <p>
    <template v-if="pickupFilters && $route.query.storeFilter">
      {{ $t.noResultsInStore }}
      <span class="block <md:mt-6">{{ $t.noResultsInStoreSubtitle }}</span>
    </template>
    <template v-else>
      {{ $t.noResults }}
    </template>
  </p>
</template>

<script lang="ts" setup>
defineProps<{
  pickupFilters: boolean
}>()
</script>
